module.exports = __webpack_public_path__ + "static/media/spain.b6a0cbdf.svg";